import { render, staticRenderFns } from "./canvas3d.vue?vue&type=template&id=408db2ec"
import script from "./canvas3d.vue?vue&type=script&lang=js"
export * from "./canvas3d.vue?vue&type=script&lang=js"
import style0 from "./canvas3d.vue?vue&type=style&index=0&id=408db2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports